import { OfficeType } from "@core/constants";

export class OfficeTypeRequestModel {
    PartitionKey: string = "";
    OfficeCd: string = "";
    constructor(partitionKey: string = "", officeCd: string = "") {
        this.PartitionKey = partitionKey;
        this.OfficeCd = officeCd;
    }
}

export class DaiInfoRequestModel {
    CorpPrefix: string = "";
    Officecd: string = "";
    FetchDate: string = "";
    OfficeType: number = OfficeType.notSupport;
    ScreenCd: string = ""; 
    ExcludeBlock91: boolean = true;
    DaiCds: string[] = [];

    constructor(
        corpPrefix: string = "", 
        officecd: string = "", 
        fetchDate: string = "",
        officeType: number = OfficeType.notSupport,
        screenCd: string = ""
    ) {
        this.CorpPrefix = corpPrefix;
        this.Officecd = officecd;
        this.FetchDate = fetchDate;
        this.OfficeType = officeType;
        this.ScreenCd = screenCd;
        this.ExcludeBlock91 = true;
        this.DaiCds = [];
    }
}

export class PeriodRequestModel {
    CorpPrefix: string = "";
    Officecd: string= "";
    OfficeType: number = OfficeType.newTsusho;
    Sdate: string= "";
    Edate: string= "";
    ScreenCd: string = "";

    constructor(
        corpPrefix: string = "",
        officecd: string = "",
        sdate: string = "",
        edate: string = "",
        officeType: number = OfficeType.newTsusho,
        screenCd: string = ""
    ) {
        this.CorpPrefix = corpPrefix;
        this.Officecd = officecd;
        this.Sdate = sdate;
        this.Edate = edate;
        this.ScreenCd = screenCd;
        this.OfficeType = officeType;
    }
}

export class AttentionListRequestModel {
    CorpPrefix: string = "";
    CorpCd: string = "";
    Officecd: string= "";
    DaiList: string[] = [];
    Sdate: string= "";
    Edate: string= "";

    constructor(
        corpPrefix: string = "",
        corpCd: string = "", 
        officecd: string = "", 
        daiList: string[] = [],
        sdate: string = "",
        edate: string = ""
    ) {
        this.CorpPrefix = corpPrefix;
        this.CorpCd = corpCd;
        this.Officecd = officecd;
        this.DaiList = daiList
        this.Sdate = sdate;
        this.Edate = edate;
    }
}

export class HolidayRequestModel {
    CorpPrefix: string = "";
    OfficeCd: string = "";
    Sdate: string = "";
    Edate: string = "";

    constructor(
        corpPrefix: string = "",
        officeCd: string = "",
        sdate: string = "",
        edate: string = ""
    ) {
        this.CorpPrefix = corpPrefix;
        this.OfficeCd = officeCd;
        this.Sdate = sdate;
        this.Edate = edate;
    }
}

export class BatheScheduledRequestModel {
    DaiCds: string[] = [];
    Sdate: string = "";
    Edate: string = "";
    ScreenCd: string = "01";

    constructor(
        daiCds: string[] = [],
        sdate: string = "",
        edate: string = "",
        screenCd: string = "01"
    ) {
        this.DaiCds = daiCds;
        this.Sdate = sdate;
        this.Edate = edate;
        this.ScreenCd = screenCd;
    }
}
